var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91081 0.925049C2.78332 0.925049 0.244141 3.46987 0.244141 6.60431C0.244141 8.24045 1.09259 10.1415 2.13475 11.8246C3.64723 14.2682 5.53784 16.2539 5.53784 16.2539C5.6352 16.3561 5.77017 16.4139 5.91081 16.4139C6.05144 16.4139 6.18641 16.3561 6.28378 16.2539C6.28378 16.2539 8.17438 14.2682 9.68687 11.8246C10.729 10.1415 11.5775 8.24045 11.5775 6.60431C11.5775 3.46987 9.03829 0.925049 5.91081 0.925049ZM5.91081 4.02283C4.48899 4.02283 3.33505 5.17933 3.33505 6.60431C3.33505 8.02929 4.48899 9.18579 5.91081 9.18579C7.33263 9.18579 8.48656 8.02929 8.48656 6.60431C8.48656 5.17933 7.33263 4.02283 5.91081 4.02283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c9eb7bb04231e917e8e03fb03ccd02ea.svg";
export { ForwardRef as ReactComponent };